import { Controller } from "@hotwired/stimulus"

const PENDING_FORMULAS = "[data-math-style]:not([data-latex])"

let katex = null
let katexLoading = null

const loadKatex = () => {
  katexLoading ||= import("katex").then(({ default: module }) => { katex = module })
  return katexLoading
}

const renderFormulas = (formulas) => {
  formulas.forEach((formula) => {
    katex.render(formula.dataset.latex, formula, {
      output: "mathml",
      displayMode: formula.dataset.mathStyle === "display",
      throwOnError: false
    })
  })
}

export default class extends Controller {
  connect() {
    this.observer = new MutationObserver(() => this.render())
    this.observer.observe(this.element, { childList: true, subtree: true })
    return this.render()
  }

  disconnect() {
    this.observer.disconnect()
  }

  render() {
    const formulas = [...this.element.querySelectorAll(PENDING_FORMULAS)]
    if (formulas.length === 0) return Promise.resolve()

    formulas.forEach((formula) => {
      formula.dataset.latex = formula.textContent.trim()
    })

    if (katex) {
      renderFormulas(formulas)
      return Promise.resolve()
    }

    return loadKatex().then(() => renderFormulas(formulas))
  }
}
